import { useEffect, useRef, useState } from "react";
import styles from "./ReportsShifts.module.css";
import {
  MdTrendingUp,
  MdTrendingDown,
  MdAccountBalanceWallet,
  MdMoneyOff,
} from "react-icons/md";
import { MoreVertical, Eye, FileSpreadsheet, FileText, DownloadCloud } from "lucide-react";
import CustomSelect from "../../customComponents/CustomSelect";

const ReportsShifts = () => {
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [openMenu, setOpenMenu] = useState(null);
  const wrapperRef = useRef(null);

  const data = [
    {
      id: 1,
      warehouse: "Кокшетау",
      employee: "Иванов Иван",
      openTime: "03.10.2025, 09:00",
      closeTime: "03.10.2025, 18:00",
      startBalance: "0 ₸",
      income: "0 ₸",
      expense: "0 ₸",
      endBalance: "0 ₸",
    },
    {
      id: 2,
      warehouse: "Караганда",
      employee: "Петров Петр",
      openTime: "02.10.2025, 08:45",
      closeTime: "02.10.2025, 17:20",
      startBalance: "0 ₸",
      income: "0 ₸",
      expense: "0 ₸",
      endBalance: "0 ₸",
    },
  ];

  const toggleMenu = (id) => {
    setOpenMenu(openMenu === id ? null : id);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className={styles.container} ref={wrapperRef}>
      <div className={styles.topRow}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Отчёт по сменам</h1>
          <p className={styles.subtitle}>Просмотр и формирование отчётов по закрытым сменам</p>
        </div>
        <div className={styles.actions}>
          <button className={styles.downloadBtn}>
            <DownloadCloud size={16} />
            <span>Скачать отчёт</span>
          </button>
        </div>
      </div>

      <div className={styles.cards}>
        <div className={`${styles.card} ${styles.green}`}>
          <div className={styles.cardHeader}>
            <MdTrendingUp className={styles.cardIcon} />
            <h3>Доход</h3>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.row}><span>Наличные</span><strong>4 667 ₸</strong></div>
            <div className={styles.row}><span>Безналичные</span><strong>93 266.40 ₸</strong></div>
            <div className={styles.sep} />
            <div className={styles.row}><span>Налоговая ставка 2%</span><strong>19 670 ₸</strong></div>
            <div className={styles.row}><span>Налоговая ставка 3%</span><strong>70 998.40 ₸</strong></div>
            <div className={styles.row}><span>Налоговая ставка 4%</span><strong>495 ₸</strong></div>
            <div className={styles.row}><span>Налоговая ставка 8%</span><strong>6 770 ₸</strong></div>
          </div>
        </div>

        <div className={`${styles.card} ${styles.red}`}>
          <div className={styles.cardHeader}>
            <MdTrendingDown className={styles.cardIcon} />
            <h3>Расход</h3>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.row}><span>Изъятие</span><strong>0 ₸</strong></div>
            <div className={styles.row}><span>Приемка</span><strong>37 250 ₸</strong></div>
            <div className={styles.row}><span>Возвраты</span><strong>110 462 ₸</strong></div>
          </div>
        </div>

        {/* Итоги */}
        <div className={`${styles.card} ${styles.blue}`}>
          <div className={styles.cardHeader}>
            <MdAccountBalanceWallet className={styles.cardIcon} />
            <h3>Итоги</h3>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.row}><span>Доход</span><strong className={styles.plus}>+ 97 933.40 ₸</strong></div>
            <div className={styles.row}><span>Расход</span><strong className={styles.minus}>- 147 712 ₸</strong></div>
          </div>
        </div>

        {/* Изъятие / Внесение (общая карточка) */}
        <div className={`${styles.card} ${styles.orange}`}>
          <div className={styles.cardHeader}>
            <MdMoneyOff className={styles.cardIcon} />
            <h3>Изъятие / Внесение</h3>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.row}><span>Сумма</span><strong>0 ₸</strong></div>
          </div>
        </div>
      </div>

      {/* Фильтры */}
      <div className={styles.filters}>
        <CustomSelect
          className={styles.select}
          options={["Кокшетау", "Караганда", "Астана"]}
          value={selectedWarehouse}
          onChange={setSelectedWarehouse}
          placeholder="Склад"
        />
        <CustomSelect
          className={styles.select}
          options={["Иванов Иван", "Петров Петр"]}
          value={selectedEmployee}
          onChange={setSelectedEmployee}
          placeholder="Сотрудник"
        />
        <input
          className={styles.dateInput}
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
        <input className={styles.smallInput} type="text" placeholder="Начальная сумма от" />
        <input className={styles.smallInput} type="text" placeholder="Начальная сумма до" />
        <input className={styles.smallInput} type="text" placeholder="Конечная сумма от" />
        <input className={styles.smallInput} type="text" placeholder="Конечная сумма до" />
      </div>

      {/* Таблица */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>№</th>
              <th>Склад</th>
              <th>Сотрудник</th>
              <th>Время открытия</th>
              <th>Время закрытия</th>
              <th>Начальный остаток</th>
              <th>Доход</th>
              <th>Расход</th>
              <th>Конечный остаток</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.warehouse}</td>
                <td>{row.employee}</td>
                <td>{row.openTime}</td>
                <td>{row.closeTime}</td>
                <td>{row.startBalance}</td>
                <td className={styles.greenText}>{row.income}</td>
                <td className={styles.redText}>{row.expense}</td>
                <td>{row.endBalance}</td>

                {/* actions cell */}
                <td className={styles.actionCell}>
                  <button
                    className={styles.moreBtn}
                    onClick={() => toggleMenu(row.id)}
                    aria-haspopup="true"
                    aria-expanded={openMenu === row.id}
                    data-more-btn
                  >
                    <MoreVertical size={18} />
                  </button>

                  {openMenu === row.id && (
                    <div className={styles.menu} data-menu-wrapper>
                      <button className={styles.menuItem}>
                        <Eye size={16} />
                        <span>Просмотр</span>
                      </button>
                      <button className={styles.menuItem}>
                        <FileSpreadsheet size={16} />
                        <span>Скачать Excel</span>
                      </button>
                      <button className={styles.menuItem}>
                        <FileText size={16} />
                        <span>Скачать PDF</span>
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsShifts;
